<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
    <el-container class="home-container">
        <!-- 添加音频元素，用于播放提示音 -->
        <audio ref="notificationSound" preload="auto" style="display: none;">
            <source src="https://cdn.jsdelivr.net/gh/Aicirou/goindex-theme-acrou@master/dist/js/music/dingdong.mp3" type="audio/mpeg">
        </audio>
        <el-aside width="305px" style="padding-left: 0; margin-left: -50px; overflow-x: hidden;">
             <el-menu :default-active="activePath" background-color="#070707" text-color="#fff" active-text-color="#8B2500" unique-opened style="height: 100%;" :popper-class="'custom-menu-popper'" :indent="24">
                <!-- Logo区域不使用菜单项，而是使用普通的div -->
                <div class="logo-menu-item" style="text-align: center; padding-left: 0;">
                    <div class="logo-container">
                        <img src="@/assets/image/logo22.png" alt="Logo" class="menu-logo-large" style="width: 160px; height: auto;margin-left:50px">
                    </div>
                </div>
                <div  style="font-weight: bold; padding: 15px 0; text-align: center; font-size: 16px; color: #ffffff !important;">共享健身后台管理系统</div>

                <!-- 动态生成菜单 -->
                <template v-for="(menu, index) in menuList">
                    <!-- 处理有子菜单的一级菜单，且不隐藏 -->
                    <el-submenu
                        v-if="menu.children && menu.children.length > 0 && !menu.isHidden"
                        :index="String(index)"
                        :key="menu.id">
                        <template slot="title">
                            <i :class="menu.icon || 'el-icon-menu'" style="color: #fff !important;"></i>
                            <span>{{menu.lbname}}</span>
                        </template>

                        <!-- 二级菜单，过滤掉隐藏的菜单 -->
                        <el-menu-item
                            v-for="child in menu.children.filter(item => !item.isHidden)"
                            :key="child.id"
                            :index="child.router"
                            @click="childMenuClick(child)">
                            <i :class="child.icon || 'el-icon-menu'" style="color: #fff !important;"></i>
                            <span>{{child.lbname}}</span>
                        </el-menu-item>

                        <!-- 特殊处理：如果是设备管理菜单，添加MQTT设备管理菜单项 -->
                        <li
                            v-if="menu.lbname === '设备管理'"
                            class="el-menu-item custom-mqtt-item"
                            style="padding-left: 20px; height: 56px; line-height: 56px; color: #fff; cursor: pointer;"
                            @click.stop="openMqttManagement">
                            <i class="el-icon-connection" style="color: #fff !important;"></i>
                            <span>MQTT设备管理</span>
                        </li>
                    </el-submenu>

                    <!-- 处理没有子菜单但有路由的一级菜单（直接作为菜单项），且不隐藏 -->
                    <el-menu-item
                        v-else-if="menu.router && menu.router !== '' && !menu.isHidden"
                        :index="menu.router"
                        :key="menu.id"
                        @click="safeMenuClick(menu)">
                        <i :class="menu.icon || 'el-icon-menu'" style="color: #fff !important;"></i>
                        <span>{{menu.lbname}}</span>
                    </el-menu-item>
                </template>

                <!-- 特殊菜单项已移除，现在只使用动态生成的菜单 -->
            </el-menu>
        </el-aside>
        <el-container>
            <el-header>
                <div style="padding-left: 20px;color:#8B2500">
                    <!-- <i class="el-icon-message-solid"></i><span style="padding-left: 10px;">下面发布一则通知.....</span> -->
                    <!-- <el-button type="primary" icon="el-icon-search">搜索</el-button>
                    <i class="el-icon-search" color="#ff0000"></i>
                    <span style="font-size:25px;color:#c7401d;padding-left:20px">共享健身后台管理系统--{{name_token}}</span> -->
                </div>
                <div class="header-user-info">
                  <div class="warningBtn" @click="handleOpenWarning" v-if="!deviceWarningFlag">
                    <img src="@/assets/image/warning.png"/>
                    <div>设备告警</div>
                  </div>
                    <span class="user-name">你好，{{name_token || '用户'}}</span>
                    <div class="notification-badge" v-show="unreadTaskCount > 0" @click="goToOrderList">
                        <span class="badge-count">{{unreadTaskCount}}</span>
                    </div>
                    <el-button @click="editDialogVisible = true">修改密码</el-button>
                    <el-button type="" @click="LogOut">退出</el-button>
                </div>
            </el-header>
            <el-main>
                <!-- 添加标签页导航 -->
                <tabs-view></tabs-view>
                <!-- 使用key强制路由视图在路由变化时重新渲染 -->
                <router-view :key="$route.fullPath"></router-view>
            </el-main>
        </el-container>

      <div class="deviceWarningContainer" v-if="deviceWarningFlag">
        <div class="deviceHeader">
          <div class="headerContent">
            设备告警
          </div>
          <img class="headerIcon" src="@/assets/image/close.png" @click="closeDeviceWarningDialog"/>
        </div>
        <div class="scroll-box">
          <!-- 大量内容 -->
          <div v-for="item in faultList" class="contentItem" :key="item.storeId">
            <div>店名：{{item.storeName}}</div>
            <div v-if="item.lx">
              <div v-for="(lx, index) in item.lx.split(',')" :key="index">
                {{lx.split('-')[0]}}：离线<span style="color: red">{{lx.split('-')[1]}}</span>分钟
              </div>
            </div>
          </div>
        </div>
      </div>

        <!--修改密码对话框-->
        <el-dialog title="修改密码" :visible.sync="editDialogVisible" width="40%" @close="editDialogClosed">
            <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                <el-form-item label="原密码" prop="password">
                    <el-input v-model="editForm.password" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="new_password">
                    <el-input v-model="editForm.new_password" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="con_password">
                    <el-input v-model="editForm.con_password" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editPass">确 定</el-button>
            </span>
        </el-dialog>
        <!--修改密码对话框-->

        <!-- 预警弹窗 - 全屏遮罩强提示 -->
        <div v-if="warningAlertVisible && currentWarning" class="warning-overlay">
            <div class="warning-modal">
                <div class="warning-header" :style="{ background: getWarningColor(currentWarning.level) }">
                    <span class="warning-icon">⚠️</span>
                    <span class="warning-title">{{ getWarningLevelText(currentWarning.level) }}预警</span>
                </div>
                <div class="warning-body">
                    <div class="warning-person">
                        <div class="person-avatar">👤</div>
                        <div class="person-name">{{ currentWarning.nickname || currentWarning.username }}</div>
                    </div>
                    <div class="warning-info">
                        <div class="info-row">
                            <span class="info-label">手机号：</span>
                            <span class="info-value">{{ currentWarning.username }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">进入店铺：</span>
                            <span class="info-value highlight">{{ currentWarning.storeName }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">进店时间：</span>
                            <span class="info-value">{{ currentWarning.recordTime }}</span>
                        </div>
                        <div class="info-row reason">
                            <span class="info-label">预警原因：</span>
                            <span class="info-value danger">{{ currentWarning.reason || '无' }}</span>
                        </div>
                    </div>
                    <div class="warning-queue-info" v-if="warningQueue.length > 1">
                        还有 <span class="queue-count">{{ warningQueue.length - 1 }}</span> 条预警待处理
                    </div>
                </div>
                <div class="warning-footer">
                    <button class="confirm-btn" @click="confirmCurrentWarning">
                        <span class="btn-icon">✓</span>
                        确认已知晓
                    </button>
                </div>
            </div>
        </div>

        <!-- 发版日志弹窗 - 全屏遮罩强提示 -->
        <div v-if="releaseNoteAlertVisible && currentReleaseNote" class="release-note-overlay">
            <div class="release-note-modal">
                <div class="release-note-header">
                    <span class="release-note-icon">🚀</span>
                    <span class="release-note-title">版本更新通知</span>
                </div>
                <div class="release-note-body">
                    <div class="release-note-version">版本号：{{ currentReleaseNote.versionNo }}</div>
                    <div class="release-note-title-text">{{ currentReleaseNote.title }}</div>
                    <div class="release-note-time">{{ currentReleaseNote.releaseTime }}</div>
                    <div class="release-note-content md-body" v-html="releaseNoteContentHtml"></div>
                    <div class="release-note-queue-info" v-if="releaseNoteQueue.length > 1">
                        还有 <span class="release-note-queue-count">{{ releaseNoteQueue.length - 1 }}</span> 个版本更新待查看
                    </div>
                </div>
                <div class="release-note-footer">
                    <button class="release-note-read-btn" @click="confirmReleaseNoteRead">
                        <span class="btn-icon">✓</span>
                        我已阅读
                    </button>
                </div>
            </div>
        </div>
    </el-container>
</template>
<script>
import TabsView from './common/TabsView.vue'
import { resolveContentHtml } from '../utils/rich-text'

export default {
    name: 'Index',
    components: { TabsView },
    data(){
        return {
            activePath:'',
            admin_token:'',
            name_token:'',
            // WebSocket连接对象
            websocket: null,
            // 心跳定时器
            heartbeatTimer: null,
            // 心跳间隔（60秒发送一次心跳）
            heartbeatInterval: 60000,
            role_token:'',
            storeid_token:'',
            perid_token:'',
            old_password:'',
            userId: '', // 添加用户ID字段
            menuList: [], // 菜单列表
            buttonPermissions: [], // 按钮权限列表
            roles: [], // 角色列表
            editDialogVisible: false, // 修改密码对话框是否可见
            editForm:{
                 password:'',
                 new_password:'',
                 con_password:''
            },
            editFormRules: {
                password: [
                    { required: true, message: '请输入原密码', trigger: 'blur' },
                    // { validator: oldPass, trigger: 'blur'}
                ],
                new_password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                con_password:[
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: this.validatePass, trigger: 'blur'}
                ],
            },
            // 未读任务数量
            unreadTaskCount: 0,
            taskTimer: null,
            userHasInteracted: false, // 用户是否已交互标志
            audioContext: null, // 音频上下文
            // 预警相关
            warningAlertVisible: false, // 预警弹窗是否可见
            currentWarning: null, // 当前预警信息
            warningQueue: [], // 预警队列
            // 发版日志弹窗相关
            releaseNoteAlertVisible: false, // 发版日志弹窗是否可见
            currentReleaseNote: null, // 当前发版日志
            releaseNoteQueue: [], // 发版日志队列

          box: null, //弹窗对象
          timer: null, //定时器
          faultList: [],
          deviceWarningFlag: true
        }
    },
    computed: {
        // 发版内容：后端 contentHtml 优先（Markdown 已在后端转 HTML），旧接口兜底转义原文
        releaseNoteContentHtml() {
            return resolveContentHtml(this.currentReleaseNote)
        }
    },
    created() {
        // 从当前路由获取活动路径
        this.activePath = this.$route.path
        // 如果sessionStorage中有保存的路径，优先使用它
        const savedPath = window.sessionStorage.getItem('activePath')
        if (savedPath) {
            this.activePath = savedPath
        }

        this.admin_token = window.sessionStorage.getItem('admin_token')
        this.name_token = window.sessionStorage.getItem('username')
        this.role_token = window.sessionStorage.getItem('role_token')
        this.storeid_token = window.sessionStorage.getItem('storeid_token')
        this.perid_token = window.sessionStorage.getItem('perid_token')
        this.userId = window.sessionStorage.getItem('userId') // 获取存储的用户ID

        // 获取按钮权限列表
        const buttonPermissionsStr = window.sessionStorage.getItem('buttonPermissions')
        if (buttonPermissionsStr) {
            try {
                this.buttonPermissions = JSON.parse(buttonPermissionsStr)
            } catch (e) {
                console.error('解析按钮权限数据失败:', e)
                this.buttonPermissions = []
            }
        }

        // 获取角色列表
        const rolesStr = window.sessionStorage.getItem('roles')
        if (rolesStr) {
            try {
                this.roles = JSON.parse(rolesStr)
            } catch (e) {
                console.error('解析角色数据失败:', e)
                this.roles = []
            }
        }

        this.old_password = window.sessionStorage.getItem('pass_token')

        // 获取菜单数据
        this.getMenuList()
        // 初始化WebSocket连接
        this.initWebSocket()

      this.initDeviceWarning()
    },

    // 监听路由变化，更新菜单高亮状态
    watch: {
        $route: {
            handler(to) {
                // 当路由变化时，更新活动路径
                // 去掉前导斜杠，确保格式一致
                const path = to.path.startsWith('/') ? to.path.substring(1) : to.path;
                this.activePath = path;
                // 保存到sessionStorage
                window.sessionStorage.setItem('activePath', path);
                ////console.log('路由变化，更新菜单激活路径:', path);
            },
            immediate: true
        }
    },
    beforeDestroy() {
        this.closeWebSocket();
        // 移除点击事件监听器
        document.removeEventListener('click', this.handleUserInteraction);
    },

    mounted() {
        // 在组件挂载后尝试初始化音频上下文
        this.$nextTick(() => {
            // 直接设置userHasInteracted为true，解决音频播放问题
            this.userHasInteracted = true;
            //console.log('已强制设置用户交互标志为true');

            // 初始化音频上下文
            this.initAudioContext();

            // 保留点击事件监听器作为备用
            document.addEventListener('click', this.handleUserInteraction);

            // 预加载通知音频
            if (this.$refs.notificationSound) {
                this.$refs.notificationSound.load();
            }

          let deviceWarningFlag = sessionStorage.getItem("deviceWarningFlag")
          if (deviceWarningFlag) {
            this.deviceWarningFlag = deviceWarningFlag === 'true'
          }
        });
    },
    methods:{
      handleOpenWarning() {
        this.deviceWarningFlag = true;
        sessionStorage.setItem('deviceWarningFlag', this.deviceWarningFlag)
        this.initDeviceWarning()
      },
      initDeviceWarning() {
        this.$nextTick(() => {
          this.box = document.querySelector('.scroll-box');

          // 鼠标移入
          this.box.addEventListener('mouseenter', () => {
            console.log('鼠标移入');

            clearInterval(this.timer);
            this.timer = null; // ⚠️ 必须置空，否则 start() 无法重新创建
          });

          // 鼠标移出
          this.box.addEventListener('mouseleave', () => {
            console.log('鼠标移出');
            this.startAutoScroll()
          });
          this.getFaultList();
        })
      },
      async getFaultList() {
        const { data: res } = await this.$http.get('/gkj/faultDevices');

          if (res) {
            this.faultList = res;
            this.startAutoScroll()
          }
      },
      startAutoScroll(speed = 1) {
        if (this.timer) return; // 防止重复启动

        this.timer = setInterval(() => {
          this.box.scrollTop += speed;
          // 滚动到底部时重置（需配合HTML复制一份内容实现无缝）
          if (this.box.scrollTop >= this.box.scrollHeight - this.box.clientHeight) {
            this.box.scrollTop = 0;
          }
        }, 50); // ≈60fps
      },
      closeDeviceWarningDialog() {
        this.deviceWarningFlag = false;
        sessionStorage.setItem('deviceWarningFlag', this.deviceWarningFlag)
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      // 获取菜单列表
        async getMenuList() {
            try {
                // 尝试从登录响应中获取用户ID
                if (!this.userId) {
                    try {
                        // 尝试从userinfo中获取用户ID
                        const userInfoStr = window.sessionStorage.getItem('userinfo');
                        if (userInfoStr) {
                            const userInfo = JSON.parse(userInfoStr);
                            if (userInfo && userInfo.length > 0 && userInfo[0].id) {
                                this.userId = userInfo[0].id;
                                window.sessionStorage.setItem('userId', this.userId);
                                console.log('成功获取并存储用户ID:', this.userId);
                            }
                        }
                    } catch (e) {
                        console.error('解析用户ID失败:', e);
                    }
                }

                // 获取所有可能的token
                const adminToken = window.sessionStorage.getItem('admin_token');
                const loginToken = window.sessionStorage.getItem('login_token');
                const roles = window.sessionStorage.getItem('roles');

                console.log('用户信息:', {
                    adminToken,
                    loginToken,
                    roles
                });

                if (!adminToken) {
                    console.error('获取菜单列表失败: 未找到用户token');
                    this.$message.error('登录状态异常，请重新登录');
                    this.$router.push('/login');
                    return;
                }

                //console.log('正在请求菜单数据，用户token:', adminToken);
                //console.log('当前baseURL:', this.$http.defaults.baseURL);

                // 尝试不同的请求方式和token格式
                let response;
                try {
                    // 尝试方式1: 带斜杠，使用Bearer前缀
                    //console.log('尝试方式1: 带斜杠，使用Bearer前缀');
                    response = await this.$http.get('getperlist/', {
                        headers: {
                            'Authorization': 'Bearer ' + adminToken
                        }
                    });
                } catch (error1) {
                    console.error('方式1失败:', error1);
                    try {
                        // 尝试方式2: 不带斜杠，使用Bearer前缀
                        //console.log('尝试方式2: 不带斜杠，使用Bearer前缀');
                        response = await this.$http.get('getperlist', {
                            headers: {
                                'Authorization': 'Bearer ' + adminToken
                            }
                        });
                    } catch (error2) {
                        console.error('方式2失败:', error2);
                        try {
                            // 尝试方式3: 带斜杠，不使用Bearer前缀
                            //console.log('尝试方式3: 带斜杠，不使用Bearer前缀');
                            response = await this.$http.get('getperlist/', {
                                headers: {
                                    'Authorization': adminToken
                                }
                            });
                        } catch (error3) {
                            console.error('方式3失败:', error3);
                            throw new Error('所有请求方式均失败');
                        }
                    }
                }

                const { data: res } = response;

                //console.log('getperlist接口返回数据:', res);

                if (res.status === 0) {
                    // 检查菜单数据是否为空
                    if (!res.data || res.data.length === 0) {
                        console.warn('后端返回的菜单数据为空，可能是权限问题');
                    }

                    // 直接使用后端返回的菜单数据，已经是层级结构
                    this.menuList = res.data || [];

                    // 打印菜单数据以便调试
                    //console.log('处理后的菜单数据:', this.menuList);

                    // 过滤一级菜单中的按钮类型项（type === 2）
                    this.menuList.forEach(menu => {
                        if (menu.children && menu.children.length > 0) {
                            // 只保留菜单类型的项目（type === 1）
                            menu.children = menu.children.filter(item => item.type === 1);

                            // 对子菜单按orderid排序
                            menu.children.sort((a, b) => a.orderid - b.orderid);
                        }
                    });

                    // 对一级菜单按orderid排序
                    this.menuList.sort((a, b) => a.orderid - b.orderid);

                    // 存储按钮权限列表
                    if (res.buttonPermissions && res.buttonPermissions.length > 0) {
                        // 获取当前用户信息
                        const username = window.sessionStorage.getItem('admin_token');
                        const rolesStr = window.sessionStorage.getItem('roles');
                        let roles = [];
                        try {
                            if (rolesStr) {
                                roles = JSON.parse(rolesStr);
                            }
                        } catch (e) {
                            console.error('解析角色数据失败:', e);
                        }

                        // 为admin用户和超级管理员添加所有按钮权限
                        let buttonPermissions = [...res.buttonPermissions];

                        // 添加管理员相关按钮权限
                        const adminButtons = ['btn:admin:edit', 'btn:admin:delete', 'btn:admin:add'];

                        // 如果是admin用户或超级管理员，添加所有管理员按钮权限
                        if (username === 'admin' || (roles && roles.includes('超级管理员'))) {
                            adminButtons.forEach(btn => {
                                if (!buttonPermissions.includes(btn)) {
                                    buttonPermissions.push(btn);
                                }
                            });
                        }

                        this.buttonPermissions = buttonPermissions;
                        // 将按钮权限存储到sessionStorage中，供v-permission指令使用
                        window.sessionStorage.setItem('buttonPermissions', JSON.stringify(buttonPermissions));
                    }
                } else {
                    this.$message.error('获取菜单列表失败')
                }
            } catch (error) {
                console.error('获取菜单列表出错:', error)
                this.$message.error('获取菜单列表出错')
            }
        },

        // 检查权限
        hasPermission(permission) {
            if (!permission) return true;

            try {
                // 超级管理员拥有所有权限
                if (this.name_token === 'admin' || (this.roles && this.roles.includes('超级管理员'))) {
                    return true;
                }

                // 检查菜单列表中是否包含该权限
                if (this.menuList && this.menuList.length > 0) {
                    // 检查菜单项的permissionCode
                    for (const menu of this.menuList) {
                        if (menu.permissionCode === permission) {
                            return true;
                        }

                        // 检查子菜单
                        if (menu.children && menu.children.length > 0) {
                            for (const child of menu.children) {
                                if (child.permissionCode === permission) {
                                    return true;
                                }
                            }
                        }
                    }

                    // 如果是菜单名称匹配（兼容旧代码）
                    for (const menu of this.menuList) {
                        if (menu.lbname === permission) {
                            return true;
                        }
                    }
                }

                // 检查按钮权限
                if (this.buttonPermissions && this.buttonPermissions.length > 0) {
                    if (this.buttonPermissions.includes(permission)) {
                        return true;
                    }
                }

                // 兼容旧的权限系统
                if (this.perid_token) {
                    try {
                        // 将字符串类型的 perid_token 转为数组
                        const peridArray = this.perid_token.replace(/'/g, '"'); // 替换单引号为双引号
                        const peridList = JSON.parse(peridArray); // 转换为数组
                        return peridList.includes(permission);
                    } catch (parseError) {
                        console.error('解析权限数据失败:', parseError);
                        // 如果解析失败，尝试直接使用字符串比较
                        return this.perid_token.includes(permission);
                    }
                }

                return false;
            } catch (e) {
                console.error('权限检查失败:', e);
                return false;
            }
        },

        // 检查按钮权限
        hasButtonPermission(permissionCode) {
            if (!permissionCode) return false;
            return this.buttonPermissions && this.buttonPermissions.includes(permissionCode);
        },

        // 关闭修改密码对话框时重置表单
        editDialogClosed() {
            this.$refs.editFormRef.resetFields();
        },

        // 验证确认密码规则
        validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入确认密码'));
            } else if (value !== this.editForm.new_password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        },

        // 安全的菜单点击处理方法
        safeMenuClick(menu) {
            try {
                // 保存当前菜单路由
                this.saveNavState(menu.router);

                // 获取目标路径 - 确保路径是绝对路径（以/开头）但不会有双斜杠
                const targetPath = menu.router.startsWith('/') ? menu.router : '/' + menu.router;
                const currentPath = this.$route.path;

                // 如果目标路径与当前路径相同，不进行导航
                if (currentPath === targetPath) {
                    return;
                }

                // 检查当前是否在编辑门店页面、标注门店页面或门店列表页面
                const isInStoreEdit = currentPath && currentPath.includes('/storeedit/');
                const isInStoreMark = currentPath && currentPath.includes('/storemark/');
                const isInStoresList = currentPath && (currentPath === '/stores' || currentPath.includes('/stores/'));

                // 从这些特殊页面导航时使用完全刷新的方式
                if (isInStoreEdit || isInStoreMark || isInStoresList) {
                    // 检查并记录token状态
                    const adminToken = window.sessionStorage.getItem('admin_token');
                    const loginToken = window.sessionStorage.getItem('login_token');
                    const joinToken = window.sessionStorage.getItem('join_token');
                    //console.log('导航前token状态:', { adminToken, loginToken, joinToken });

                    // 从门店相关页面导航到其他页面，使用完全刷新的方式
                    //console.log('从门店相关页面导航到:', menu.router);

                    // 确保在导航前先存储当前的token
                    if (!adminToken && !loginToken && !joinToken) {
                        console.warn('警告: 导航前未找到有效token!');
                    }

                    // 使用完全刷新的方式导航，确保组件完全卸载并重新加载
                    // 确保路径是绝对路径（以/开头）但不会有双斜杠
                    const hashPath = menu.router.startsWith('/') ? menu.router : '/' + menu.router;
                    window.location.href = '#' + hashPath;
                } else {
                    // 正常导航
                    this.$router.push(targetPath).catch(err => {
                        // 忽略重复导航错误
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('导航错误:', err);
                        }
                    });
                }
            } catch (error) {
                console.error('菜单点击处理错误:', error);
                // 出错时尝试使用更直接的方式导航
                // 确保路径是绝对路径（以/开头）但不会有双斜杠
                const hashPath = menu.router.startsWith('/') ? menu.router : '/' + menu.router;
                window.location.href = '#' + hashPath;
            }
        },

        // 原始的菜单点击处理方法（保留作为备用）
        handleMenuClick(menu) {
            this.saveNavState(menu.router);
            // 确保路径是绝对路径（以/开头）但不会有双斜杠
            const targetPath = menu.router.startsWith('/') ? menu.router : '/' + menu.router;
            this.$router.push(targetPath);
        },

        // 保存导航状态
        saveNavState(path) {
            // 将被点击的导航菜单对应的路由路径保存到 sessionStorage 中
            window.sessionStorage.setItem('activePath', path);
            this.activePath = path;
        },

        // 子菜单项点击：显式导航（不再依赖 el-menu 的 router 模式）
        // 规避“子菜单收起时首次点击只展开不跳转、需点第二次才生效”的问题
        childMenuClick(child) {
            const targetPath = child.router.startsWith('/') ? child.router : '/' + child.router;
            this.saveNavState(child.router);
            const currentPath = this.$route.path;
            if (currentPath === targetPath) {
                return;
            }
            this.$router.push(targetPath).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error('子菜单导航错误:', err);
                }
            });
        },

        // 退出登录
        async LogOut() {
            try {
                // 先调用后端 /logout 接口，让后端记录退出日志
                await this.$http.post('/logout');
            } catch (e) {
                console.error('调用退出接口失败', e);
            } finally {
                // 关闭 WebSocket 连接
                this.closeWebSocket();
                // 清除所有的 sessionStorage 数据
                window.sessionStorage.clear();
                // 跳转到登录页面
                this.$router.push('/login');
            }
        },

        // 打开新窗口
        openNewWindow(url) {
            // 在新窗口打开指定的URL，并设置noopener和noreferrer属性以防止新窗口访问父窗口
            // 这样可以避免新窗口影响当前页面的会话状态
            const newWindow = window.open();
            if (newWindow) {
                newWindow.opener = null;
                newWindow.location = url;
            } else {
                // 如果弹窗被阻止，提示用户
                this.$message.warning('弹窗被浏览器阻止，请允许弹窗后重试');
            }
        },

        // 打开MQTT设备管理
        openMqttManagement(event) {
            // 阻止事件冒泡和默认行为
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            // 直接使用原生方式打开新窗口，完全绕过Vue路由系统
            // const url = 'http://8.130.182.156:18083/#/login?to=/dashboard/overview';
            const url = 'http://8.130.39.76:18083/#/login?to=/dashboard/overview';
            // const url = 'http://192.168.0.11:18083/#/login?to=/dashboard/overview';

            // 创建一个隐藏的原生按钮并模拟点击
            const button = document.createElement('button');
            button.style.display = 'none';
            document.body.appendChild(button);

            // 添加点击事件
            button.onclick = () => {
                // 使用浏览器原生的window.open方法
                const newWindow = window.open('', '_blank');
                if (newWindow) {
                    // 切断与父窗口的联系
                    newWindow.opener = null;
                    // 设置目标URL
                    newWindow.location.href = url;
                } else {
                    // 如果浏览器阻止了弹窗，显示提示
                    this.$message.warning('新窗口被浏览器阻止，请允许弹窗后重试');
                }

                // 移除按钮
                document.body.removeChild(button);
            };

            // 模拟点击
            button.click();

            // 防止可能的内存泄漏
            setTimeout(() => {
                if (document.body.contains(button)) {
                    document.body.removeChild(button);
                }
            }, 100);

            // 阻止Vue路由导航
            return false;
        },

        // 修改密码
        editPass() {
            // 首先对表单进行验证
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return;

                try {
                    // 获取存储的用户ID
                    const userId = window.sessionStorage.getItem('userId');
                    if (!userId) {
                        this.$message.error('用户ID不存在，请重新登录');
                        return;
                    }

                    //console.log('修改密码使用的用户ID:', userId);

                    // 发送修改密码请求
                    const { data: res } = await this.$http.post('/admin/password', {
                        id: parseInt(userId), // 使用从 sessionStorage 获取的用户ID
                        oldPassword: this.editForm.password,
                        newPassword: this.editForm.new_password
                    });

                    //console.log('修改密码响应:', res);

                    // 兼容两种响应格式
                    if (res.code === 200 || res.status === 0) {
                        // 密码修改成功
                        this.$message.success(res.data || res.message || '密码修改成功！');
                        // 关闭对话框
                        this.editDialogVisible = false;
                        // 更新存储的密码
                        window.sessionStorage.setItem('pass_token', this.editForm.new_password);
                    } else {
                        this.$message.error(res.msg || res.message || '密码修改失败！');
                    }
                } catch (error) {
                    console.error('修改密码出错:', error);
                    this.$message.error('修改密码请求失败，请重试！');
                }
            });
        },

        /**
         * 初始化WebSocket连接
         */
        initWebSocket() {
            // 获取用户ID，用于建立WebSocket连接
            const userId = window.sessionStorage.getItem('userId');
            if (!userId) {
                console.error('用户ID不存在，无法建立WebSocket连接');
                return;
            }

            // 构建WebSocket连接URL
            // 根据当前页面协议自动选择WebSocket协议
            const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

            // 使用与API相同的后端地址和端口
            // 从 axios.defaults.baseURL 中提取域名和端口
            // const apiBaseUrl = 'http://192.168.0.90:7707/';
            // const apiBaseUrl = 'https://jianshenhtapi.xiajianjian.com/';
            const apiBaseUrl = 'https://jianshenhtapi.tieshouyundong.com/';
            const apiUrlObj = new URL(apiBaseUrl);
            const backendHost = apiUrlObj.host; // 提取域名和端口

            //console.log('使用与API相同的后端地址:', backendHost);

            // WebSocket连接地址
            const wsUrl = `${protocol}//${backendHost}/websocket/systemTask/${userId}`;

            //console.log('正在连接WebSocket:', wsUrl);

            try {
                // 创建WebSocket连接
                this.websocket = new WebSocket(wsUrl);

                // 连接建立时的回调
                this.websocket.onopen = this.websocketOnOpen;
                // 收到消息时的回调
                this.websocket.onmessage = this.websocketOnMessage;
                // 连接关闭时的回调
                this.websocket.onclose = this.websocketOnClose;
                // 连接出错时的回调
                this.websocket.onerror = this.websocketOnError;
            } catch (error) {
                console.error('WebSocket连接失败:', error);
                // 连接失败时，使用定时器作为备选方案
                this.fallbackToTimer();
            }
        },

        /**
         * WebSocket连接成功的回调
         */
        websocketOnOpen() {
            console.log('✅✅✅ WebSocket连接成功！');
            // 连接成功后，可以向服务器发送消息
            this.websocket.send('getUnprocessedTaskCount');

            // 启动心跳定时器
            this.startHeartbeat();
        },

        /**
         * 启动心跳定时器
         */
        startHeartbeat() {
            // 先清除可能存在的定时器
            this.stopHeartbeat();

            // 设置定时器，定期发送心跳包
            this.heartbeatTimer = setInterval(() => {
                if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
                    // 发送ping消息
                    this.websocket.send('ping');
                    //console.log('发送心跳包ping');
                } else {
                    // 如果连接已关闭，尝试重新连接
                    this.reconnectWebSocket();
                }
            }, this.heartbeatInterval);
        },

        /**
         * 停止心跳定时器
         */
        stopHeartbeat() {
            if (this.heartbeatTimer) {
                clearInterval(this.heartbeatTimer);
                this.heartbeatTimer = null;
            }
        },

        /**
         * 收到WebSocket消息的回调
         */
        websocketOnMessage(event) {
            // 先检查是否是简单的心跳响应
            if (event.data === 'pong') {
                //console.log('收到心跳响应: pong');
                return;
            }

            try {
                // 解析服务器发送的JSON消息
                const message = JSON.parse(event.data);
                // 打印所有收到的消息，便于调试
                console.log('📨 收到WebSocket消息:', JSON.stringify(message));
                console.log('📨 消息类型:', message.type);

                // 记录当前的未读数量
                const previousCount = this.unreadTaskCount;

                // 根据消息类型处理
                // 处理预警消息
                if (message.type === 'warningAlert') {
                    console.warn('⚠️⚠️⚠️ 收到预警消息:', message.data);
                    this.showWarningAlert(message.data);
                    return;
                }

                // 处理发版日志弹窗
                if (message.type === 'releaseNoteAlert') {
                    console.warn('🚀 收到发版日志弹窗消息:', message.data);
                    this.showReleaseNoteAlert(message.data);
                    return;
                }

                // 处理设备故障告警
                if (message.type === 'deviceFaultAlert') {
                  console.warn('🔧 收到设备故障消息:', message.data);
                  this.getFaultList();
                  return;
                }

                if (message.type === 'unprocessedTaskCount' || message.type === 'unprocessedTasks') {
                    // 始终更新未处理任务数量，无论是增加还是减少
                    //console.log('更新未处理任务数量:', message.count, '(之前:', previousCount + ')');

                    // 将消息中的count转换为整数
                    const newCount = parseInt(message.count, 10);
                    //console.log('解析后的未读数量:', newCount, '类型:', typeof newCount);

                    // 使用Vue的响应式系统更新未读数量
                    // 先保存当前值供比较
                    const oldCount = this.unreadTaskCount;

                    // 使用Vue.$set确保响应式更新
                    this.$set(this, 'unreadTaskCount', newCount);

                    // 也直接设置属性值
                    this.unreadTaskCount = newCount;

                    //console.log('未读数量从', oldCount, '更新为', newCount);

                    // 直接更新DOM元素
                    this.updateBadgeDOM(newCount);

                    // 在下一个渲染周期检查
                    this.$nextTick(() => {
                        //console.log('更新后的未读数量为:', this.unreadTaskCount, '类型:', typeof this.unreadTaskCount);
                        // 再次直接更新DOM
                        this.updateBadgeDOM(newCount);
                    });

                    // 延迟再次检查和更新
                    setTimeout(() => {
                        //console.log('延迟检查未读数量:', this.unreadTaskCount);
                        if (this.unreadTaskCount !== newCount) {
                            //console.log('检测到数量不一致，再次强制更新');
                            this.unreadTaskCount = newCount;
                            this.$forceUpdate();
                            this.updateBadgeDOM(newCount);
                        }
                    }, 500);

                    // 如果未读数量增加，播放提示音并语音播报
                    if (newCount > previousCount && newCount > 0) {
                        //console.log('任务数量增加，从', previousCount, '到', newCount, '，播放通知');
                        // 确保播放通知和语音播报
                        setTimeout(() => {
                            this.playNotificationSound();
                            this.speakNotification('您有新的退款申请');
                        }, 100); // 延迟100毫秒，确保 DOM 更新完成
                    }
                    // 如果任务数量减少，记录日志
                    else if (message.count < previousCount) {
                        //console.log('任务数量减少，从', previousCount, '到', message.count);
                    }

                    // 如果需要，也可以存储任务列表（仅适用于unprocessedTasks类型）
                    if (message.type === 'unprocessedTasks' && message.tasks) {
                        // this.tasks = message.tasks;
                        //console.log('收到任务列表数据');
                    }
                }
            } catch (error) {
                console.error('解析WebSocket消息失败:', error);
            }
        },

        /**
         * WebSocket连接关闭的回调
         */
        websocketOnClose() {
            //console.log('WebSocket连接已关闭');
            // 连接关闭后，可以尝试重新连接
            this.reconnectWebSocket();
        },

        /**
         * WebSocket连接出错的回调
         */
        websocketOnError(error) {
            console.error('WebSocket连接出错:', error);
            // 连接出错后，可以尝试重新连接
            this.reconnectWebSocket();
        },

        /**
         * 重新连接WebSocket
         */
        reconnectWebSocket() {
            // 如果已经存在重连定时器，先清除
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
            }

            // 设置重连定时器，5秒后尝试重新连接
            this.reconnectTimer = setTimeout(() => {
                //console.log('尝试重新连接WebSocket...');
                this.initWebSocket();
            }, 5000);
        },

        /**
         * 关闭WebSocket连接
         */
        closeWebSocket() {
            // 停止心跳
            this.stopHeartbeat();

            if (this.websocket) {
                // 关闭WebSocket连接
                this.websocket.close();
                this.websocket = null;
            }

            // 清除重连定时器
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
            }
        },

        /**
         * 当WebSocket连接失败时，回退到使用定时器获取未处理任务数量
         */
        fallbackToTimer() {
            //console.log('回退到使用定时器获取未处理任务数量');
            // 先清除可能存在的定时器
            if (this.taskTimer) {
                clearInterval(this.taskTimer);
            }

            // 立即获取一次未读任务数量
            this.getUnreadTaskCount();

            // 设置定时器，每30秒获取一次未读任务数量
            this.taskTimer = setInterval(() => {
                this.getUnreadTaskCount();
            }, 30000);
        },

        /**
         * 直接更新DOM元素中的红点数量
         * @param {Number} count - 未读任务数量
         */
        updateBadgeDOM(count) {
            try {
                //console.log('直接更新DOM元素中的红点数量:', count);

                // 查找自定义红点元素
                const badgeCount = document.querySelector('.badge-count');
                const notificationBadge = document.querySelector('.notification-badge');

                if (badgeCount) {
                    //console.log('找到badge-count元素，更新内容为:', count);
                    badgeCount.textContent = count.toString();
                } else {
                    //console.log('未找到badge-count元素');
                }

                if (notificationBadge) {
                    //console.log('找到notification-badge元素，设置显示状态');
                    if (count > 0) {
                        notificationBadge.style.display = '';
                        //console.log('显示红点，数量:', count);
                    } else {
                        notificationBadge.style.display = 'none';
                        //console.log('隐藏红点，数量为0');
                    }
                } else {
                    //console.log('未找到notification-badge元素');
                }

                // 同时检查Element UI的徽章元素
                const elBadges = document.querySelectorAll('.el-badge__content');
                if (elBadges && elBadges.length > 0) {
                    //console.log('找到', elBadges.length, '个Element UI徽章元素');
                    elBadges.forEach(badge => {
                        if (badge.textContent && !isNaN(parseInt(badge.textContent))) {
                            badge.textContent = count.toString();
                            if (count === 0) {
                                badge.style.display = 'none';
                            } else {
                                badge.style.display = '';
                            }
                        }
                    });
                }
            } catch (error) {
                console.error('更新红点DOM元素失败:', error);
            }
        },

        /**
         * 通过HTTP请求获取未处理任务数量
         */
        async getUnreadTaskCount() {
            try {
                const { data: res } = await this.$http.get('/systemtask/count', {
                    params: { status: 0 } // 0表示未处理
                });

                if (res.code === 200) {
                    // 使用$set确保响应式更新
                    const newCount = parseInt(res.count, 10);
                    //console.log('通过HTTP获取的未读数量:', newCount);
                    this.$set(this, 'unreadTaskCount', newCount);
                    this.unreadTaskCount = newCount;
                    this.$forceUpdate();
                } else {
                    console.error('获取未处理任务数量失败:', res.msg);
                }
            } catch (error) {
                console.error('获取未处理任务数量请求失败:', error);
            }
        },

        /**
         * 处理用户交互事件
         * 用于初始化音频上下文，解决自动播放限制
         */
        handleUserInteraction() {
            //console.log('检测到用户交互');
            // 设置用户交互标志
            this.userHasInteracted = true;

            // 尝试初始化音频上下文
            this.initAudioContext();

            // 初始化成功后可以移除事件监听器
            if (this.audioContext) {
                document.removeEventListener('click', this.handleUserInteraction);
                //console.log('音频上下文初始化成功，已移除交互监听器');
            }
        },

        /**
         * 初始化音频上下文
         * 应在用户交互时调用此方法，如点击页面时
         */
        initAudioContext() {
            if (!this.audioContext && window.AudioContext) {
                try {
                    // 创建音频上下文
                    this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
                    //console.log('音频上下文初始化成功');

                    // 创建一个短暂的静音缓冲区并播放，以激活音频上下文
                    const silentBuffer = this.audioContext.createBuffer(1, 1, 22050);
                    const source = this.audioContext.createBufferSource();
                    source.buffer = silentBuffer;
                    source.connect(this.audioContext.destination);
                    source.start(0);

                    // 预加载通知音频
                    if (this.$refs.notificationSound) {
                        this.$refs.notificationSound.load();
                    }

                    return true;
                } catch (error) {
                    console.error('初始化音频上下文失败:', error);
                    return false;
                }
            }
            return !!this.audioContext;
        },

        /**
         * 播放通知提示音
         */
        playNotificationSound() {
            try {
                // 检查用户是否已经交互过
                if (!this.userHasInteracted) {
                    console.warn('通知提示音需要用户交互，已跳过音频播放');
                    this.showVisualNotification(); // 显示视觉通知作为替代
                    return;
                }

                // 首先尝试使用AudioContext API播放声音
                if (this.audioContext) {
                    // 如果已经创建了音频上下文，直接播放
                    const dingDongBuffer = this.createDingDongBuffer(this.audioContext);
                    const source = this.audioContext.createBufferSource();
                    source.buffer = dingDongBuffer;
                    source.connect(this.audioContext.destination);
                    source.start(0);
                    //console.log('使用AudioContext播放声音成功');
                    return; // 播放成功，直接返回
                } else if (window.AudioContext) {
                    // 尝试初始化并播放
                    this.initAudioContext();

                    // 如果初始化成功，立即播放
                    if (this.audioContext) {
                        const dingDongBuffer = this.createDingDongBuffer(this.audioContext);
                        const source = this.audioContext.createBufferSource();
                        source.buffer = dingDongBuffer;
                        source.connect(this.audioContext.destination);
                        source.start(0);
                        //console.log('初始化并使用AudioContext播放声音成功');
                        return; // 播放成功，直接返回
                    }
                }

                // 如果AudioContext不可用或失败，尝试使用传统的Audio方式
                if (this.$refs.notificationSound) {
                    // 使用预加载的音频元素
                    this.$refs.notificationSound.currentTime = 0;

                    // 使用Promise处理播放可能的失败
                    const playPromise = this.$refs.notificationSound.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                            //console.log('通知提示音播放成功');
                        }).catch(error => {
                            console.warn('通知提示音播放被浏览器限制:', error);
                            // 显示一个视觉提示，因为音频播放被阻止
                            this.showVisualNotification();
                        });
                    }
                } else {
                    // 如果没有预加载的音频元素，创建一个
                    const audio = new Audio();
                    // audio.src = 'https://cdn.jsdelivr.net/gh/Aicirou/goindex-theme-acrou@master/dist/js/music/dingdong.mp3';

                    // 其他通知音效选项，可以取消注释并替换上面的音效
                    // 温柔提示音
                    // audio.src = 'https://cdn.jsdelivr.net/npm/notification-mp3/dist/notification.mp3';

                    // 清脆铃声
                    // audio.src = 'https://cdn.jsdelivr.net/gh/fateicr/assets@main/sounds/bell.mp3';

                    // 电子通知音
                    // audio.src = 'https://cdn.jsdelivr.net/gh/fateicr/assets@main/sounds/notification.mp3';

                    // 流行通知音
                    audio.src = 'https://cdn.jsdelivr.net/gh/fateicr/assets@main/sounds/pristine.mp3';

                    // 简短提示音
                    // audio.src = 'https://cdn.jsdelivr.net/gh/fateicr/assets@main/sounds/quite-impressed.mp3';

                    const playPromise = audio.play();
                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                            //console.log('动态创建的音频播放成功');
                        }).catch(error => {
                            console.warn('动态创建的音频播放被浏览器限制:', error);
                            // 显示一个视觉提示，因为音频播放被阻止
                            this.showVisualNotification();
                        });
                    }
                }
            } catch (error) {
                console.error('所有音频播放方式都失败:', error);
                // 显示一个视觉提示，因为音频播放失败
                this.showVisualNotification();
            }
        },

        /**
         * 显示视觉通知提示
         * 当音频播放失败时的备用方案
         */
        showVisualNotification() {
            // 闪烁通知徽章
            if (this.unreadTaskCount > 0) {
                const badge = document.querySelector('.notification-badge');
                if (badge) {
                    badge.classList.add('flash-animation');
                    setTimeout(() => {
                        badge.classList.remove('flash-animation');
                    }, 2000);
                }

                // 可选：显示一个Element UI通知
                this.$notify({
                    title: '新通知',
                    message: '您有新的未处理退款申请',
                    type: 'warning',
                    duration: 3000
                });
            }
        },

        /**
         * 创建铃声音频数据
         * @param {AudioContext} audioContext 音频上下文
         * @returns {AudioBuffer} 音频缓冲区
         */
        createDingDongBuffer(audioContext) {
            // 创建一个1秒钟的音频缓冲区，单声道，44.1kHz采样率
            const sampleRate = audioContext.sampleRate;
            const duration = 0.3;  // 音频时长（秒）
            const buffer = audioContext.createBuffer(1, sampleRate * duration, sampleRate);

            // 获取音频数据
            const data = buffer.getChannelData(0);

            // 生成铃声音频数据
            const ding = sampleRate * 0.15;  // 第一个音的时长
            const pause = sampleRate * 0.05; // 两个音之间的停顿

            // 第一个音（高音）
            for (let i = 0; i < ding; i++) {
                // 频率较高的正弦波
                data[i] = Math.sin(i * 0.04) * Math.exp(-i * 0.002);
            }

            // 第二个音（低音）
            for (let i = 0; i < ding; i++) {
                // 频率较低的正弦波
                data[i + ding + pause] = Math.sin(i * 0.03) * Math.exp(-i * 0.002) * 0.7;
            }

            return buffer;
        },

        /**
         * 语音播报通知
         * @param {string} text 要播报的文本
         */
        speakNotification(text) {
            try {
                // 始终显示视觉通知，无论语音是否成功
                this.showVisualNotification();

                // 检查浏览器是否支持语音合成
                if (!('speechSynthesis' in window)) {
                    console.warn('浏览器不支持语音合成API');
                    return;
                }

                // 强制设置用户交互标志为true
                this.userHasInteracted = true;

                // 创建语音合成实例
                const utterance = new SpeechSynthesisUtterance(text);

                // 获取可用的语音列表
                let voices = window.speechSynthesis.getVoices();

                // 如果语音列表为空，等待语音加载
                if (!voices || voices.length === 0) {
                    //console.log('语音列表为空，等待语音加载...');
                    // 尝试等待语音加载
                    window.speechSynthesis.onvoiceschanged = () => {
                        voices = window.speechSynthesis.getVoices();
                        this.completeVoiceSetup(utterance, voices, text);
                    };
                    return;
                }

                this.completeVoiceSetup(utterance, voices, text);
            } catch (error) {
                console.error('语音播报失败:', error);
            }
        },

        /**
         * 完成语音设置和播放
         */
        completeVoiceSetup(utterance, voices, text) {
            try {
                //console.log('可用语音列表:', voices.map(v => v.name));

                // 尝试找到中文女声
                let femaleVoice = voices.find(voice =>
                    voice.lang && voice.lang.includes('zh') &&
                    (voice.name.includes('Female') || voice.name.includes('女') || voice.name.includes('Mei'))
                );

                // 如果找不到中文女声，就使用默认中文语音
                if (!femaleVoice) {
                    femaleVoice = voices.find(voice => voice.lang && voice.lang.includes('zh'));
                }

                // 如果找到合适的语音，就使用它
                if (femaleVoice) {
                    utterance.voice = femaleVoice;
                    //console.log('使用语音:', femaleVoice.name);
                }

                // 设置语音属性，调整为更自然的声音
                utterance.lang = 'zh-CN'; // 使用中文
                utterance.volume = 1.0;   // 音量（0-1）

                // 语速设置 - 稍慢一点更自然
                utterance.rate = 0.9;     // 语速（0.1-10），0.9更自然

                // 音调设置 - 标准女声，不要太高
                utterance.pitch = 1.1;    // 音调（0-2），1.1更自然柔和

                // 添加事件监听器
                utterance.onstart = () => {
                    //console.log('语音播报开始:', text);
                };

                utterance.onend = () => {
                    //console.log('语音播报结束');
                };

                utterance.onerror = (event) => {
                    console.error('语音播报出错:', event);
                    if (event.error === 'not-allowed') {
                        console.warn('语音播报被浏览器限制，尝试使用其他方式通知');
                        // 尝试使用音频通知代替
                        this.playNotificationSound();
                    }
                };

                // 尝试播放语音
                window.speechSynthesis.cancel(); // 先取消之前的语音播报
                window.speechSynthesis.speak(utterance);
                //console.log('已请求语音播报:', text);
            } catch (error) {
                console.error('完成语音设置失败:', error);
            }
        },

        /**
         * 跳转到订单列表页面
         */
        goToOrderList() {
            // 保存导航状态
            this.saveNavState('orders');
            // 跳转到订单列表页面
            this.$router.push('/orders');
        },

        /**
         * 显示预警弹窗
         */
        showWarningAlert(warningData) {
            console.warn('⚠️ 收到预警:', warningData);

            // 检查是否已在队列中（避免重复）
            const exists = this.warningQueue.some(w => w.id === warningData.id);
            if (!exists) {
                this.warningQueue.push(warningData);
            }

            // 如果当前没有显示预警，显示第一个
            if (!this.warningAlertVisible) {
                this.showNextWarning();
            }

            // 播放提示音
            this.playNotificationSound();

            // 语音播报
            const levelText = this.getWarningLevelText(warningData.level);
            const speakText = `注意，${levelText}预警，${warningData.nickname || warningData.username}进入${warningData.storeName}`;
            this.speakNotification(speakText);

            // 发送浏览器通知
            if ('Notification' in window && Notification.permission === 'granted') {
                new Notification('⚠️ 预警通知', {
                    body: `${warningData.nickname || warningData.username} 进入 ${warningData.storeName}`,
                    icon: '/favicon.ico',
                    requireInteraction: true
                });
            }
        },

        /**
         * 显示下一个预警
         */
        showNextWarning() {
            if (this.warningQueue.length > 0) {
                this.currentWarning = this.warningQueue[0];
                this.warningAlertVisible = true;
            } else {
                this.currentWarning = null;
                this.warningAlertVisible = false;
            }
        },

        /**
         * 显示发版日志弹窗
         */
        showReleaseNoteAlert(noteData) {
            // 检查是否已在队列中（避免重复）
            const exists = this.releaseNoteQueue.some(n => n.id === noteData.id);
            if (!exists) {
                this.releaseNoteQueue.push(noteData);
            }

            // 如果当前没有显示，显示第一个
            if (!this.releaseNoteAlertVisible) {
                this.showNextReleaseNote();
            }
        },

        /**
         * 显示下一条发版日志
         */
        showNextReleaseNote() {
            if (this.releaseNoteQueue.length > 0) {
                this.currentReleaseNote = this.releaseNoteQueue[0];
                this.releaseNoteAlertVisible = true;
            } else {
                this.currentReleaseNote = null;
                this.releaseNoteAlertVisible = false;
            }
        },

        /**
         * 确认已读发版日志（调用后端接口写 Redis 已读状态，后续不再弹窗）
         */
        async confirmReleaseNoteRead() {
            if (!this.currentReleaseNote) return;

            const noteId = this.currentReleaseNote.id;
            const userId = window.sessionStorage.getItem('userId') || '';

            try {
                const { data: res } = await this.$http.post('/release-note/read', {
                    noteId: noteId,
                    userId: userId
                });

                if (res.code === 200 || res.status === 0) {
                    console.log('发版日志已读:', noteId);
                } else {
                    console.warn('标记发版日志已读响应异常:', res);
                }
            } catch (error) {
                console.error('标记发版日志已读失败:', error);
            }

            // 无论接口是否成功，都关闭当前弹窗并展示下一条
            this.releaseNoteQueue.shift();
            this.showNextReleaseNote();
        },

        /**
         * 确认当前预警
         */
        async confirmCurrentWarning() {
            if (!this.currentWarning) return;

            const warningId = this.currentWarning.id;

            try {
                const confirmBy = this.name_token || window.sessionStorage.getItem('username') || '未知用户';
                console.log('确认预警:', warningId, '确认人:', confirmBy);

                const { data: res } = await this.$http.post('/warning/confirm', {
                    id: warningId,
                    confirmBy: confirmBy
                });

                if (res.code === 200 || res.status === 0) {
                    console.log('预警确认成功');
                    this.$message.success('预警已确认');

                    // 从队列中移除已确认的预警
                    this.warningQueue = this.warningQueue.filter(w => w.id !== warningId);

                    // 显示下一个预警
                    this.showNextWarning();
                } else {
                    console.error('预警确认失败:', res.msg);
                    this.$message.error('确认失败，请重试');
                }
            } catch (error) {
                console.error('确认预警请求失败:', error);
                this.$message.error('网络错误，请重试');
            }
        },

        /**
         * 获取预警级别颜色
         */
        getWarningColor(level) {
            const colors = {
                1: 'linear-gradient(135deg, #909399, #606266)',
                2: 'linear-gradient(135deg, #E6A23C, #F39C12)',
                3: 'linear-gradient(135deg, #F56C6C, #E74C3C)'
            };
            return colors[level] || colors[3];
        },

        /**
         * 获取预警级别文字
         */
        getWarningLevelText(level) {
            const texts = { 1: '普通', 2: '重要', 3: '紧急' };
            return texts[level] || '紧急';
        },

        /**
         * 确认预警（兼容旧方法）
         */
        async confirmWarningAlert(warningId) {
            try {
                const confirmBy = this.name_token || window.sessionStorage.getItem('username') || '未知用户';
                const { data: res } = await this.$http.post('/warning/confirm', {
                    id: warningId,
                    confirmBy: confirmBy
                });

                if (res.code === 200 || res.status === 0) {
                    console.log('预警确认成功');
                }
            } catch (error) {
                console.error('确认预警请求失败:', error);
            }
        }
    }
}
</script>
<style>
    /* 覆盖Element UI的默认黄色悬停样式 - 最高优先级 */
    .el-menu-item:hover,
    .el-menu-item:focus,
    .el-submenu__title:hover,
    .el-submenu__title:focus,
    .el-menu--horizontal>.el-menu-item:hover,
    .el-menu--horizontal>.el-menu-item:focus,
    .el-menu--horizontal>.el-submenu .el-submenu__title:hover,
    .el-menu--horizontal>.el-submenu .el-submenu__title:focus,
    .el-menu--popup .el-menu-item:hover,
    .el-menu--popup .el-menu-item:focus,
    .el-menu--popup .el-submenu__title:hover,
    .el-menu--popup .el-submenu__title:focus,
    .el-menu .el-menu-item:hover,
    .el-menu .el-menu-item:focus,
    .el-menu .el-submenu__title:hover,
    .el-menu .el-submenu__title:focus,
    /* 直接覆盖默认的黄色背景 */
    .el-menu .el-menu-item[style*="background-color: rgb(254, 244, 182)"],
    .el-menu .el-menu-item[style*="background-color: #fef4b6"],
    .el-menu .el-submenu__title[style*="background-color: rgb(254, 244, 182)"],
    .el-menu .el-submenu__title[style*="background-color: #fef4b6"],
    .el-menu--popup .el-menu-item[style*="background-color: rgb(254, 244, 182)"],
    .el-menu--popup .el-menu-item[style*="background-color: #fef4b6"] {
        background-color: #070707 !important;
        color: #fff !important;
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
    }

    /* 全局禁用菜单项悬停效果 - 最高优先级 */
    .el-menu-item:hover,
    .el-menu-item:focus,
    .el-submenu__title:hover,
    .el-submenu__title:focus,
    .el-menu--horizontal>.el-menu-item:hover,
    .el-menu--horizontal>.el-menu-item:focus,
    .el-menu--horizontal>.el-submenu .el-submenu__title:hover,
    .el-menu--horizontal>.el-submenu .el-submenu__title:focus,
    .el-menu--popup .el-menu-item:hover,
    .el-menu--popup .el-menu-item:focus,
    .el-menu--popup .el-submenu__title:hover,
    .el-menu--popup .el-submenu__title:focus,
    .el-menu .el-menu-item:hover,
    .el-menu .el-menu-item:focus,
    .el-menu .el-submenu__title:hover,
    .el-menu .el-submenu__title:focus,
    /* 添加更多选择器组合 */
    .el-menu *:hover,
    .el-menu *:focus,
    .el-menu--popup *:hover,
    .el-menu--popup *:focus,
    .el-submenu *:hover,
    .el-submenu *:focus,
    .el-menu-item *:hover,
    .el-menu-item *:focus,
    .el-submenu__title *:hover,
    .el-submenu__title *:focus,
    /* 通配符匹配所有可能的菜单相关元素 */
    [class*="el-menu"] *:hover,
    [class*="el-menu"] *:focus,
    [class*="el-submenu"] *:hover,
    [class*="el-submenu"] *:focus {
        background-color: #070707 !important;
        color: #fff !important;
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        transition: none !important;
    }

    .home-container{
        padding-top:0px;
        height: 100%;
    }
    /* 红点通知样式 */
    .notification-badge {
        position: relative;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #f56c6c;
        border-radius: 50%;
        margin-right: 15px;
        cursor: pointer;
        animation: pulse 1.5s infinite;
    }

    .badge-count {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 12px;
        font-weight: bold;
    }

    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.7);
        }
        70% {
            box-shadow: 0 0 0 6px rgba(245, 108, 108, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
        }
    }
    .el-header{
        background-color: #ffffff;
        /* background-image: linear-gradient(to right,#6f82e1,#5165f8); */
        display: flex;
        justify-content: space-between;
        padding-left: 100px;
        align-items: center;
        font-size: 20px;
        color: #fff;
        height: 60px !important;
    }
    .el-aside{
	    background-color:#070707; /* 侧边栏背景色同步改为深色，与白色文字搭配 */
    }
    .el-main {
        background-color:#FAFAFA;
    }
    .el-menu {
		border-right: none;
    }
    /* 移除这个样式，使用更具体的选择器 */
    .el-submenu__title,.el-dropdown-menu__item, .el-menu-item{
        font-size: 16px !important;
        color: #fff !important; /* 文字颜色改为白色 */
    }
    .el-submenu__title i,
    .el-menu-item i {
        color: #fff !important; /* 图标颜色改为白色 */
    }
    .el-submenu__title{
        /* 移除右边距，避免影响菜单层级布局 */
        margin-right: 0;
    }

    /* 添加logo相关样式 */
    .logo-container {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .menu-logo {
        width: 24px;
        height: 24px;
        margin-right: 5px;
    }

    .menu-logo-large {
        width: 75%;
        height: auto;
        margin: 20px 25px 5px -5px;
        object-fit: contain;
    }

    /* 添加右上角用户名样式 */
    .header-user-info {
        display: flex;
        align-items: center;
    }

    .warningBtn{
      border: 1px solid #FF4600;
      color: #FF4600;
      font-size: 14px;
      padding: 5px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      img{
        width: 12px;
        height: 14px;
      }
      margin-right: 5px;
    }

    .user-name {
        margin-right: 15px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }

    /* 增强一级菜单图标样式优先级 */
    .el-menu .el-submenu__title i {
        color: #fff !important; /* 图标颜色改为白色 */
    }

    .el-menu .el-submenu > .el-submenu__title i {
         color: #fff !important; /* 图标颜色改为白色 */
    }

    /* 更强的样式规则确保图标为白色 */
    .home-container .el-aside .el-menu .el-submenu__title i {
        color: #fff !important; /* 图标颜色改为白色 */
        opacity: 1 !important;
    }

    /* 防止图标被设置为黑色 */
    .el-menu .el-submenu__title .el-icon-menu,
    .el-menu .el-submenu__title [class*="el-icon-"] {
        color: #fff !important; /* 图标颜色改为白色 */
    }

    /* 使用深度选择器强制设置图标颜色 */
    /deep/ .el-submenu__title i {
         color: #fff !important; /* 图标颜色改为白色 */
    }

    /deep/ .el-menu-item i {
       color: #fff !important; /* 图标颜色改为白色 */
    }

    /* 最强的样式规则 */
    .home-container >>> .el-submenu__title i,
    .home-container >>> .el-menu-item i {
        color: #fff !important; /* 图标颜色改为白色 */
    }
    /* 菜单项的默认样式 */
    .el-menu-item {
        font-size: 14px;
        font-weight: normal;
        transition: all 0.3s ease;
        /* 移除右边距，避免影响菜单层级布局 */
        margin-right: 0;
    }

    /* 增强一级菜单和二级菜单的层级区分 */
    /* 有子菜单的一级菜单 */
    .el-menu .el-submenu > .el-submenu__title {
        padding-left: 20px !important;
        border-left: 4px solid transparent;
        position: relative;
        margin-right: 0;
        background-color: #070707 !important;
        font-size: 15px;
        font-weight: bold;
    }

    /* 没有子菜单的一级菜单 */
    .el-menu > .el-menu-item {
        padding-left: 20px !important;
        border-left: 4px solid transparent;
        position: relative;
        margin-right: 0;
        background-color: #070707 !important;
        font-size: 15px;
        font-weight: bold;
    }

    /* 二级菜单 */
    .el-menu .el-submenu .el-menu-item {
        padding-left: 40px !important;
        min-width: auto !important;
        border-left: 3px solid transparent;
        margin-left: 40px;
        position: relative;
        left: 50px;
        background-color: #0a0a0a !important;
        width: 180px;
        font-size: 13px;
        color: #cccccc !important;
    }

    /* 鼠标悬停时的样式 */
    /* 有子菜单的一级菜单悬停 */
    .el-menu .el-submenu > .el-submenu__title:hover {
        border-left: 4px solid #409EFF;
        background-color: #111111 !important;
    }

    /* 没有子菜单的一级菜单悬停 */
    .el-menu > .el-menu-item:hover {
        border-left: 4px solid #409EFF;
        background-color: #111111 !important;
    }

    /* 二级菜单悬停 */
    .el-menu .el-submenu .el-menu-item:hover {
        border-left: 3px solid #67C23A;
        background-color: #151515 !important;
    }

    /* 移除菜单项悬停效果 */
    /* 禁用默认的悬停背景色和文字颜色 */
    .el-menu--horizontal>.el-submenu:hover .el-submenu__title,
    .el-menu--horizontal>.el-menu-item:hover,
    .el-menu-item:focus,
    .el-submenu__title:hover {
        background-color: transparent !important;
        color: #fff !important;
    }

    /* 强制覆盖Element UI的默认悬停样式 */
    .el-menu--popup .el-menu-item:hover,
    .el-menu--popup .el-menu-item:focus {
        background-color: transparent !important;
        color: #fff !important;
    }

    /* 防止菜单项悬停时变为黄色 */
    .el-menu--popup-bottom-start .el-menu-item:hover,
    .el-menu--popup-right-start .el-menu-item:hover,
    .el-menu--popup-top-start .el-menu-item:hover,
    .el-menu--popup-left-start .el-menu-item:hover {
        background-color: transparent !important;
        color: #fff !important;
    }

    /* 菜单选中状态样式增强 - 主要强调字体变化 */
    .el-menu-item.is-active,
    .custom-mqtt-item.is-active {
        font-weight: 600 !important; /* 适中的字体粗细 */
        font-size: 15px !important; /* 适当的字体大小 */
        letter-spacing: 0.5px !important; /* 适当的字间距 */
        color: #8B2500 !important; /* 更暗的红褐色 */
        padding-left: 20px !important; /* 适当的左侧缩进 */
        transform: scale(1.02); /* 更细微的放大效果 */
        background-color: rgba(139, 37, 0, 0.1) !important; /* 添加轻微的背景色 */
    }

    /* 子菜单选中状态样式增强 */
    .el-submenu .el-menu-item.is-active {
        font-weight: 600 !important;
        font-size: 15px !important;
        letter-spacing: 0.5px !important;
        color: #8B2500 !important;
        padding-left: 40px !important; /* 适当的子菜单缩进 */
        transform: scale(1.02);
        background-color: rgba(139, 37, 0, 0.1) !important; /* 添加轻微的背景色 */
    }

    /* 选中菜单的图标样式 */
    .el-menu-item.is-active i,
    .custom-mqtt-item.is-active i {
        color: #8B2500 !important;
    }

    /* 完全禁用菜单项的鼠标悬停效果 - 最强制的方式 */
    .el-menu-item,
    .el-submenu__title,
    .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
    .el-menu--horizontal .el-submenu .el-submenu__title:hover,
    .el-menu-item:focus,
    .el-menu-item:hover,
    .el-submenu__title:hover,
    .custom-mqtt-item:hover,
    .el-menu--popup .el-menu-item:hover,
    .el-menu--popup .el-menu-item:focus,
    .el-menu .el-menu-item:hover,
    .el-menu .el-menu-item:focus,
    .el-menu .el-submenu__title:hover,
    .el-menu .el-submenu__title:focus {
        background-color: #070707 !important;
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        transition: none !important;
        color: #fff !important;
    }

    /* 强制覆盖默认黄色背景 */
    .el-menu li.is-active,
    .el-menu--horizontal>.el-menu-item.is-active,
    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: none !important;
        background-color: rgba(139, 37, 0, 0.1) !important;
    }

    /* 强制覆盖所有默认的黄色和高亮 */
    .el-menu,
    .el-menu--horizontal,
    .el-menu--vertical,
    .el-menu--collapse,
    .el-menu--popup,
    .el-menu .el-menu,
    .el-menu--popup .el-menu {
        background-color: #070707 !important;
        border: none !important;
    }

    /* 移除所有可能的黄色背景 */
    [class*="el-menu"] [style*="background-color: rgb(254, 244, 182)"],
    [class*="el-menu"] [style*="background-color: #fef4b6"],
    [class*="el-menu"] [style*="background-color:rgb(254,244,182)"],
    [class*="el-menu"] [style*="background-color:#fef4b6"] {
        background-color: transparent !important;
    }

    /* 自定义下拉菜单样式 */
    .custom-menu-popper .el-menu,
    .el-menu--popup {
        background-color: #070707 !important;
        border: none !important;
    }

    .custom-menu-popper .el-menu-item,
    .el-menu--popup .el-menu-item {
        color: #fff !important;
        background-color: #070707 !important;
    }

    .custom-menu-popper .el-menu-item:hover,
    .el-menu--popup .el-menu-item:hover {
        background-color: transparent !important;
        color: #fff !important;
    }

    .custom-menu-popper .el-menu-item.is-active,
    .el-menu--popup .el-menu-item.is-active {
        color: #8B2500 !important;
        background-color: rgba(139, 37, 0, 0.1) !important;
    }

    /* Logo区域的样式 */
    .logo-menu-item {
        padding: 10px 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #070707;
    }


    .logo-container {
        text-align: center;
    }

    .menu-logo-large {
        height: 40px;
    }

    /* 闪烁动画 */
    @keyframes flash {
        0% { opacity: 1; }
        50% { opacity: 0.3; }
        100% { opacity: 1; }
    }

    .flash-animation {
        animation: flash 0.5s ease-in-out infinite;
    }

    /* 预警弹窗样式 */
    .warning-alert-dialog {
        border-radius: 10px;
    }
    .warning-alert-dialog .el-message-box__header {
        background: linear-gradient(135deg, #F56C6C, #E6A23C);
        border-radius: 10px 10px 0 0;
        padding: 15px;
    }
    .warning-alert-dialog .el-message-box__title {
        color: #fff;
        font-size: 18px;
    }
    .warning-alert-dialog .el-message-box__content {
        padding: 30px 20px;
    }
    .warning-alert-dialog .el-message-box__btns {
        padding: 15px 20px 20px;
    }
    .warning-alert-dialog .el-button--primary {
        background-color: #F56C6C;
        border-color: #F56C6C;
    }
    .warning-alert-dialog .el-button--primary:hover {
        background-color: #f78989;
        border-color: #f78989;
    }
    /* 禁用所有可能的悬停效果 - 最强力的方式 */
    .el-menu,
    .el-menu--horizontal,
    .el-menu--vertical,
    .el-menu--collapse,
    .el-menu--popup,
    .el-submenu,
    .el-menu-item,
    .el-submenu__title,
    .custom-mqtt-item {
        pointer-events: auto !important;
    }

    /* 移除阻止点击的样式 */

    /* 禁用所有过渡效果 */
    .el-menu,
    .el-menu *,
    .el-menu--horizontal,
    .el-menu--horizontal *,
    .el-menu--vertical,
    .el-menu--vertical *,
    .el-menu--collapse,
    .el-menu--collapse *,
    .el-menu--popup,
    .el-menu--popup *,
    .el-submenu,
    .el-submenu *,
    .el-menu-item,
    .el-menu-item *,
    .el-submenu__title,
    .el-submenu__title *,
    .custom-mqtt-item,
    .custom-mqtt-item * {
        -webkit-transition: none !important;
        -moz-transition: none !important;
        -o-transition: none !important;
        transition: none !important;
        -webkit-transform: none !important;
        -moz-transform: none !important;
        -o-transform: none !important;
        transform: none !important;
    }

    /* ========== 预警弹窗样式 ========== */
    .warning-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes slideIn {
        from { transform: scale(0.8) translateY(-20px); opacity: 0; }
        to { transform: scale(1) translateY(0); opacity: 1; }
    }

    @keyframes pulse-border {
        0%, 100% { box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.7); }
        50% { box-shadow: 0 0 0 15px rgba(245, 108, 108, 0); }
    }

    .warning-modal {
        width: 420px;
        background: #fff;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
        animation: slideIn 0.4s ease, pulse-border 2s infinite;
    }

    .warning-header {
        padding: 24px;
        text-align: center;
        color: #fff;
    }

    .warning-icon {
        font-size: 48px;
        display: block;
        margin-bottom: 10px;
        animation: shake 0.5s ease infinite;
    }

    @keyframes shake {
        0%, 100% { transform: rotate(0deg); }
        25% { transform: rotate(-10deg); }
        75% { transform: rotate(10deg); }
    }

    .warning-title {
        font-size: 28px;
        font-weight: bold;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .warning-body {
        padding: 30px;
        background: #f8f9fa;
    }

    .warning-person {
        text-align: center;
        margin-bottom: 24px;
    }

    .person-avatar {
        font-size: 60px;
        margin-bottom: 10px;
    }

    .person-name {
        font-size: 24px;
        font-weight: bold;
        color: #303133;
    }

    .warning-info {
        background: #fff;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }

    .info-row {
        display: flex;
        padding: 12px 0;
        border-bottom: 1px solid #eee;
        font-size: 15px;
    }

    .info-row:last-child {
        border-bottom: none;
    }

    .info-row.reason {
        background: #fff5f5;
        margin: 12px -20px -20px;
        padding: 16px 20px;
        border-radius: 0 0 12px 12px;
    }

    .info-label {
        color: #909399;
        width: 90px;
        flex-shrink: 0;
    }

    .info-value {
        color: #303133;
        flex: 1;
        font-weight: 500;
    }

    .info-value.highlight {
        color: #409EFF;
        font-weight: bold;
    }

    .info-value.danger {
        color: #F56C6C;
        font-weight: bold;
    }

    .warning-queue-info {
        text-align: center;
        margin-top: 16px;
        padding: 10px;
        background: #fdf6ec;
        border-radius: 8px;
        color: #E6A23C;
        font-size: 14px;
    }

    .queue-count {
        font-weight: bold;
        font-size: 18px;
        color: #F56C6C;
    }

    .warning-footer {
        padding: 20px 30px 30px;
        background: #f8f9fa;
    }

    .confirm-btn {
        width: 100%;
        padding: 16px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        background: linear-gradient(135deg, #67C23A, #5DAF34);
        border: none;
        border-radius: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(103, 194, 58, 0.4);
    }

    .confirm-btn:hover {
        background: linear-gradient(135deg, #85ce61, #67C23A);
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(103, 194, 58, 0.5);
    }

    .confirm-btn:active {
        transform: translateY(0);
    }

    .btn-icon {
        font-size: 20px;
    }

    /* ========== 发版日志弹窗样式 ========== */
    .release-note-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 99998;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: fadeIn 0.3s ease;
    }

    .release-note-modal {
        width: 480px;
        max-height: 80vh;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
        animation: slideIn 0.4s ease;
    }

    .release-note-header {
        padding: 24px;
        text-align: center;
        color: #fff;
        background: linear-gradient(135deg, #409EFF, #7c4dff);
        flex-shrink: 0;
    }

    .release-note-icon {
        font-size: 48px;
        display: block;
        margin-bottom: 10px;
        animation: shake 0.5s ease infinite;
    }

    .release-note-title {
        font-size: 24px;
        font-weight: bold;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .release-note-body {
        padding: 24px;
        background: #f8f9fa;
        overflow-y: auto;
        flex: 1;
    }

    .release-note-version {
        display: inline-block;
        padding: 4px 14px;
        border-radius: 20px;
        background: #ecf5ff;
        color: #409EFF;
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 12px;
    }

    .release-note-title-text {
        font-size: 20px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 8px;
    }

    .release-note-time {
        font-size: 13px;
        color: #909399;
        margin-bottom: 16px;
    }

    .release-note-content {
        background: #fff;
        border-radius: 12px;
        padding: 16px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        color: #303133;
        font-size: 14px;
        line-height: 1.8;
        white-space: pre-wrap;
        word-break: break-word;
        text-align: left;
    }

    /* 发版内容（Markdown 转 HTML 后由 v-html 渲染） */
    .release-note-content.md-body p {
        margin: 0 0 8px;
    }

    .release-note-content.md-body p:last-child {
        margin-bottom: 0;
    }

    .release-note-content.md-body h1,
    .release-note-content.md-body h2,
    .release-note-content.md-body h3,
    .release-note-content.md-body h4,
    .release-note-content.md-body h5,
    .release-note-content.md-body h6 {
        margin: 12px 0 8px;
        font-weight: 600;
        line-height: 1.4;
    }

    .release-note-content.md-body h1 {
        font-size: 20px;
    }

    .release-note-content.md-body h2 {
        font-size: 18px;
    }

    .release-note-content.md-body h3,
    .release-note-content.md-body h4,
    .release-note-content.md-body h5,
    .release-note-content.md-body h6 {
        font-size: 15px;
    }

    .release-note-content.md-body ul,
    .release-note-content.md-body ol {
        margin: 0 0 8px;
        padding-left: 24px;
    }

    .release-note-content.md-body li {
        margin: 2px 0;
    }

    .release-note-content.md-body blockquote {
        margin: 0 0 8px;
        padding: 6px 12px;
        border-left: 4px solid #ebEEF5;
        background: #fafafa;
        color: #606266;
    }

    .release-note-content.md-body code {
        padding: 1px 5px;
        background: #f5f7fa;
        border-radius: 3px;
        font-family: Consolas, Monaco, monospace;
        font-size: 13px;
    }

    .release-note-content.md-body pre {
        margin: 0 0 8px;
        padding: 10px 12px;
        background: #f5f7fa;
        border-radius: 6px;
        overflow-x: auto;
        white-space: pre;
    }

    .release-note-content.md-body pre code {
        padding: 0;
        background: transparent;
    }

    .release-note-content.md-body a {
        color: #409eff;
    }

    .release-note-content.md-body img {
        max-width: 100%;
    }

    .release-note-content.md-body hr {
        border: none;
        border-top: 1px solid #ebEEF5;
        margin: 12px 0;
    }

    .release-note-queue-info {
        text-align: center;
        margin-top: 16px;
        padding: 10px;
        background: #fdf6ec;
        border-radius: 8px;
        color: #E6A23C;
        font-size: 14px;
    }

    .release-note-queue-count {
        font-weight: bold;
        font-size: 18px;
        color: #F56C6C;
    }

    .release-note-footer {
        padding: 20px 30px 30px;
        background: #f8f9fa;
        flex-shrink: 0;
    }

    .release-note-read-btn {
        width: 100%;
        padding: 16px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        background: linear-gradient(135deg, #409EFF, #7c4dff);
        border: none;
        border-radius: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(64, 158, 255, 0.4);
    }

    .release-note-read-btn:hover {
        background: linear-gradient(135deg, #66b1ff, #9a6bff);
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5);
    }

    .release-note-read-btn:active {
        transform: translateY(0);
    }

    .deviceWarningContainer{
      width: 343px;
      height: 375px;
      border-radius: 20px;
      position: absolute;
      z-index: 100;
      top: 150px;
      right: 30px;
      background: white;
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.25);

      .deviceHeader{
        background: #FF8D63;
        height: 50px;
        display: flex;
        align-items: center;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;

        .headerContent{
          flex: 1;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          color: #333333;
        }
        .headerIcon{
          height: 14px;
          width: 14px;
          margin-right: 15px;
        }
      }
    }
    .scroll-box {
      margin-top: 15px;
      height: 280px;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 transparent;
      padding: 15px;
      padding-top: 0;
    }
    .scroll-box::-webkit-scrollbar { width: 6px; }
    .scroll-box::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }
    .scroll-box::-webkit-scrollbar-track { background: transparent; }
    .contentItem{
      margin-bottom: 15px;
      background: #FFF8F6;
      border-radius: 8px;
      color: #333333;
      font-size: 16px;
      padding: 10px 15px 5px;
      div {
        margin-bottom: 5px;
      }
    }
</style>
